/**
 * Shared PropTypes shapes for core data models
 * Use these for consistency across components
 */
import PropTypes from "prop-types";

export const BreakShape = PropTypes.shape({
  id: PropTypes.string,
  startTime: PropTypes.number,
  endTime: PropTypes.number,
  durationHours: PropTypes.number,
  startTimeEmployee: PropTypes.number,
  endTimeEmployee: PropTypes.number,
  durationHoursEmployee: PropTypes.number,
  breakTimesOverridden: PropTypes.bool,
});

export const ShiftShape = PropTypes.shape({
  id: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  // COALESCE values (employer wins when present, otherwise employee)
  timezone: PropTypes.string,
  startTime: PropTypes.number,
  endTime: PropTypes.number,
  referenceNumber: PropTypes.string,
  // Employee original values (for struck-through display when overridden)
  timezoneEmployee: PropTypes.string,
  startTimeEmployee: PropTypes.number,
  endTimeEmployee: PropTypes.number,
  referenceNumberEmployee: PropTypes.string,
  breaks: PropTypes.arrayOf(BreakShape),
  projectToken: PropTypes.string,
  projectName: PropTypes.string,
  projectNameEmployee: PropTypes.string,
  projectOverridden: PropTypes.bool,
  assignmentPayRateId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  notes: PropTypes.string,
  shiftDuration: PropTypes.number,
  shiftDurationEmployee: PropTypes.number,
  hoursWorked: PropTypes.number,
  hoursWorkedEmployee: PropTypes.number,
  hoursWorkedEmployer: PropTypes.number,
  anyValueOverridden: PropTypes.bool,
  shiftTimesOverridden: PropTypes.bool,
  hoursOverridden: PropTypes.bool,
  hasBreaks: PropTypes.bool,
  referenceNumberOverridden: PropTypes.bool,
  timezoneOverridden: PropTypes.bool,
  notesEmployee: PropTypes.string,
  notesEmployer: PropTypes.string,
  hoursBreakEmployee: PropTypes.number,
  isSubmitted: PropTypes.bool,
  isApproved: PropTypes.bool,
  isBackshift: PropTypes.bool,
  createdByManager: PropTypes.bool,
  isApprovableByUser: PropTypes.bool,
  isEditableByManager: PropTypes.bool,
});

export const ProjectOptionShape = PropTypes.shape({
  token: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  payRateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  payRateName: PropTypes.string,
  hourlyRate: PropTypes.number,
});

export const AssignmentPayRateProjectShape = PropTypes.shape({
  projectToken: PropTypes.string,
  projectName: PropTypes.string,
  payRate: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hourlyRate: PropTypes.number,
    name: PropTypes.string,
    isPrimary: PropTypes.bool,
  }),
});

export const ActivePayRateShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hourlyRate: PropTypes.number,
  isPrimary: PropTypes.bool,
});

export const TimezoneShape = PropTypes.shape({
  tzname: PropTypes.string.isRequired,
  display_name: PropTypes.string.isRequired,
  utc_offset: PropTypes.string.isRequired,
});

export const HolidayShape = PropTypes.shape({
  id: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  name: PropTypes.string,
  hours: PropTypes.number,
  workedHours: PropTypes.number,
  workedHoursMultiplier: PropTypes.number,
  policyCode: PropTypes.string,
  policyDescription: PropTypes.string,
});

export const PtoRequestShape = PropTypes.shape({
  id: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  hours: PropTypes.number,
  status: PropTypes.string,
  notes: PropTypes.string,
});

export const DayShape = PropTypes.shape({
  date: PropTypes.instanceOf(Date),
  shifts: PropTypes.arrayOf(ShiftShape),
  ptoRequests: PropTypes.arrayOf(PtoRequestShape),
  holidays: PropTypes.arrayOf(HolidayShape),
  totalShiftHours: PropTypes.number,
  totalPtoHours: PropTypes.number,
  totalHolidayHours: PropTypes.number,
  totalHolidayWorkedHours: PropTypes.number,
  totalHours: PropTypes.number,
  isSubmitted: PropTypes.bool,
  isApproved: PropTypes.bool,
  hasAnyOverride: PropTypes.bool,
});
